import React from 'react';
import { observer } from 'mobx-react';

import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';
import { HasNode } from 'libs/editor/plugins/helpers/hasNode';

import { HeaderMargin } from './styles';

const HeaderThreeNode = observer(({ attributes, children }) => (
  <HeaderMargin marginBottom level={3} size='xmedium' {...attributes}>
    {children}
  </HeaderMargin>
));

const type = 'header_three';
const active = value => HasNode(type, value);

export function HeaderThree() {
  return {
    button: {
      elementType: 'node',
      type,
      active,
      handleClick: store => {
        const { value, reference, onChange } = store;
        if (active(value)) {
          reference.setBlocks('paragraph');
        } else {
          reference.setBlocks(type);
        }
        onChange(reference);
      },
    },
    plugins: [RenderNode(type, props => <HeaderThreeNode {...props} />)],
  };
}
